import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import InputUI from '../../../components/UI/InputUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { translate, convertToSeparator, isNullOrEmpty, showMessageToastCustom, getDefaultPrint, autoFocus } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import BackButton from '../../../components/UI/BackButton';
import ScannerCode from '../../../components/UI/ScannerCode';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';
import Select from '../../../components/UI/Select';
import { Button, SelectResource } from '../../../components/UI/ComponentsUI';
import useStateWithPromise from '../../../utils/useEffectUpdate';

const ReceiptByLabel = (props) => {
    const automaticPrint = props.sheds ? props.sheds.find((i) => i.id === props.user.shed)?.automaticPrint : false
    const [receipt, setReceipt] = useState();
    const [filter, setFilter] = useStateWithPromise({
        shed: props.user.shed,
        qrCode: '',
        notFinished: true,
        pending: true,
        partNumber: '',
        automaticPrint: automaticPrint,
        invoice: '',
        qmeLabel: '',
        mdrLabel: '',
        confirmLabel: false,
        print: getDefaultPrint(getVision()),
        resourceId: props.user?.resource || '',
    });

    useEffect(() => {
        autoFocus("qrCode");
        // eslint-disable-next-line
    }, []);

    const onChangeLabel = (value) => {
        if (!isNullOrEmpty(value)) {
            if (value.length >= 55) {
                filter.partNumber = value.substring(0, 11);
                filter.accoutingQuantity = value.substring(39, 44);
                filter.mdrLabel = value.substring(44, 48);
                filter.qmeLabel = value.substring(48, 52);
                filter.invoice = value.substring(55, 64);

                setFilter({ ...filter }).then(() => {
                    onConfirm()
                });
            }
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            onChangeLabel(e.target.value);
        }
    }

    const onConfirm = () => {
        if (validateInputsRequired("confirmLabel")) {
            filter.printer = props.user.printer
            props.receiveByLabel(filter, (response) => {
                if (response && response.receipt && !response.automaticSuccess) {
                    filter.confirmLabel = filter.automaticPrint;
                    setFilter({ ...filter });
                    setReceipt({ ...response.receipt })
                } else {
                    filter.qrCode = ""
                    setFilter({ ...filter })
                }
            });
        }
    }

    const validateShed = (item) => {
        if (getVision() !== VISIONS.Jeep && props.user.shed !== item.physicalConfirmationShed?.shed) {
            const msg = translate('message-validate-shed', 'physical-confirmation').replace('userShed', props.user.shed).replace('itemShed', item.physicalConfirmationShed?.shed);
            showMessageToastCustom(translate('general:warning'),
                msg,
                4000, 'mdi mdi-alert-circle-outline red-text');
        } else {

            props.createConfirmation(item, '', item.mdr);
            props.history.push({
                pathname: `./confirmation`,
                state: { goBack: true },
                ...props
            });

        }
    };

    const renderItem = (item) => {
        return (
            <li
                onClick={() => validateShed(item)}
                key={`${item.id}`}
                className="collection-item"
                style={{ backgroundColor: 'white', color: 'black' }}
            >
                <div key={`${item.id}-div`}>
                    <div className="row" style={{ marginBottom: '0px', wordWrap: 'break-word' }}>
                        <div className="title black-text col s12" style={{ padding: '0px' }}>{item.partNumberCode}</div>
                        <div className="col s12 second-text-color" style={{ padding: '0px' }}>{item.partNumberDescription}</div>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:mvm')}: ${item.physicalConfirmation.mvmNumber}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:qme')}: ${convertToSeparator(item.qme) || 0}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('available', 'general')}: ${convertToSeparator(item.balance) || 0}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:mdr')}: ${item.mdr || ''}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:qt-receipt')}: ${item.accoutingQuantity - item.balance || 0}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:note')}: ${item.invoice || ''}`}</small>
                        <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:shed')}: ${item.physicalConfirmationShed?.shed || ""}`} </small>
                    </div>
                </div>
            </li>
        )
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65" />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '3px', paddingTop: '10px' }}>
                        <div className="input-field no-padding col s12">
                            <ScannerCode onScanner={onChangeLabel} className="mdi mdi-barcode-scan posfix disable" />
                            <InputUI
                                disabled={isNullOrEmpty(filter.print) || (filter.print !== ENUMS.ePrintTypes.NotPrint.value && isNullOrEmpty(filter.resourceId))}
                                required
                                label={translate('physical-confirmation:label')}
                                id="qrCode"
                                name="qrCode"
                                minLength={54}
                                type="text"
                                onChange={(e) => {
                                    onChange(e);
                                    onChangeLabel(e.target.value)
                                }}
                                onKeyDown={(e) => handleOnKeyDown(e)}
                                value={filter.qrCode}
                            />
                        </div>
                        <div className="input-field no-padding  col s12">
                            <Select
                                notOption
                                required
                                id="print"
                                name="print"
                                display="name"
                                label={translate('print-type', 'physical-confirmation')}
                                placeholder={translate('choose-one-option', 'general')}
                                data={[
                                    { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                    { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                    { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                ]}
                                change={onChange}
                                defaultValue={filter.print}
                            />
                        </div>
                        <div className="input-field no-padding  col s12">
                            <SelectResource
                                name="resourceId"
                                id="resourceId"
                                required
                                filterArea
                                shedId={props.user.shed}
                                value={filter.resourceId}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </div>
                {
                    filter.confirmLabel && receipt &&
                    <div className="card">
                        <div id="confirmLabel" className="card-content" style={{ padding: '3px', paddingTop: '10px' }}>
                            <div className='row'>
                                <div className="input-field no-padding col s12">
                                    <span className="title col s12" style={{ color: 'red' }}>
                                        Foram encontradas as seguintes divergências, favor selecionar valores para armazenamento
                                    </span>
                                </div>{
                                    filter.mdrLabel !== receipt.mdr &&
                                    <div className="input-field no-padding  col s12">
                                        <Select
                                            notOption
                                            required
                                            id="mdrLabel"
                                            name="mdrLabel"
                                            display="name"
                                            label="Selecione o MDR"
                                            placeholder={translate('choose-one-option', 'general')}
                                            data={[
                                                { id: filter.mdrLabel, text: `MDR Etiqueta Latam ${filter.mdrLabel}` },
                                                { id: receipt.mdr, text: `MDR Registro ${receipt.mdr}` },
                                            ]}
                                            change={onChange}
                                            defaultValue={filter.mdrLabel}
                                        />
                                    </div>
                                }
                                {
                                    filter.qmeLabel !== receipt.qme &&
                                    <div className="input-field no-padding  col s12">
                                        <Select
                                            notOption
                                            required
                                            id="qmeLabel"
                                            name="qmeLabel"
                                            display="name"
                                            label="Selecione o QME"
                                            placeholder={translate('choose-one-option', 'general')}
                                            data={[
                                                { id: filter.qmeLabel, text: `QME Etiqueta Latam ${filter.qmeLabel}` },
                                                { id: receipt.qme, text: `QME Registro ${receipt.qme}` },
                                            ]}
                                            change={onChange}
                                            defaultValue={filter.qmeLabel}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                        </div>
                    </div>
                }
            </div>
            {
                receipt && !filter.confirmLabel &&
                <ul className="collection col s12" >
                    {renderItem(receipt)}
                </ul>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.physicalConfirmationReducer.filter,
        resources: state.logisticsResourceReducer.list,
        sheds: state.configReducer.sheds
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        receiveByLabel: (filter, callback) => {
            dispatch(PhysicalConfirmationService.receiveByLabel(filter, callback));
        },
        createConfirmation: (receiptItem, quantity, mdrType) => {
            dispatch(PhysicalConfirmationService.createConfirmation(receiptItem, quantity, mdrType));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptByLabel));